import { SvgButton } from "../../commons/SvgButton";
import { CopySvg } from "../../inlinesvgs/CopySvg";
import { SwapLeftSvg } from "../../inlinesvgs/SwapLeftSvg";
import { SwapRightSvg } from "../../inlinesvgs/SwapRightSvg";
import { PasteSvg } from "../../inlinesvgs/PasteSvg";
import { TrashBinSvg } from "../../inlinesvgs/TrashBinSvg";
import { ZaunCircleMenuItem } from "./ZaunCircleMenuItem";
import { I18N } from "oc-I18N";
import { sleep } from "oc-commons/Commons";

export function ZaunCircleMenuItemIcons({ zaunCircleMenu }) {
  const agt = APP.arrangement;
  const selected = APP.arrangement?.selectedObjects[0];
  if (selected == null || selected.isPfosten) {
    return null;
  }

  const { elementLinks, elementRechts } = selected;
  const isFlippedNormal = selected.segment?.flippedNormal;

  const deleteContract = () => {
    return (
      agt.selectedObjects.length > 0 &&
      agt.selectedObjects.every((e) => !e.isEmpty) &&
      !agt.selectedObjects.some((e) => e.isPfosten)
    );
  };

  const copyContract = () =>
    ((APP.arrangement.copiedEntity == null &&
      agt.selectedObjects.length == 1 &&
      !agt.selectedObjects[0].isEmpty) ||
      (APP.arrangement.copiedEntity != null && agt.selectedObjects.length > 0)) &&
    !agt.selectedObjects.some((o) => o.isAufbau && o.aufbauMeta?.Key != "Mauer");

  const isTauschMöglich = ([element, nachbar]) => {
    if (!(element && nachbar)) return false;
    const segment = element?.segment;
    return segment && segment.getParts().includes(nachbar);
  };

  return (
    <ZaunCircleMenuItem dataButtonKey={I18N("aria::Elementaktionen")}>
      <span
        style={{ display: "flex", gap: "0.5rem" }}
        role="group"
        aria-label={I18N("aria::Bearbeitungswerkzeuge")}
      >
        <SvgButton
          size="large"
          title={I18N("Swap left")}
          active={
            !selected?.isAufbau &&
            isTauschMöglich(isFlippedNormal ? [elementRechts, selected] : [selected, elementLinks])
          }
          onClick={() => {
            APP.arrangement.tauscheBenachbarteElemente(
              isFlippedNormal ? [elementRechts, selected] : [selected, elementLinks]
            );
            APP.dirty();
            APP.logUserAction({ action: "tauscheBenachbarteElementeLinks" });
          }}
        >
          <SwapLeftSvg />
        </SvgButton>

        <SvgButton
          size="large"
          title={I18N("Swap right")}
          active={
            !selected?.isAufbau &&
            isTauschMöglich(isFlippedNormal ? [elementLinks, selected] : [selected, elementRechts])
          }
          onClick={() => {
            APP.arrangement.tauscheBenachbarteElemente(
              isFlippedNormal ? [elementLinks, selected] : [selected, elementRechts]
            );
            APP.dirty();
            APP.logUserAction({ action: "tauscheBenachbarteElementeRechts" });
          }}
        >
          <SwapRightSvg />
        </SvgButton>

        <SvgButton
          size="large"
          title={I18N("Kopieren")}
          active={copyContract()}
          onClick={(event) => {
            event.stopPropagation();
            APP.arrangement.copySelected();
            APP.arrangement.setSelectedObjects(null);
            APP.dirty();
            APP.logUserAction({ action: "copyButton" });
          }}
        >
          <CopySvg />
        </SvgButton>

        <SvgButton
          size="large"
          title={I18N("Einfügen")}
          active={copyContract() && APP.arrangement.copiedEntity}
          onClick={(event) => {
            event.stopPropagation();
            APP.arrangement.pasteSelected();
            APP.arrangement.copiedEntity = null;
            APP.dirty();
            APP.logUserAction({ action: "pasteButton" });
          }}
        >
          <PasteSvg />
        </SvgButton>

        <SvgButton
          size="large"
          title={I18N("Löschen")}
          active={deleteContract()}
          onClick={async (event) => {
            event.stopPropagation();
            zaunCircleMenu.current.implodeSelectCircle();
            APP.arrangement.removeSelectedObjects();
            APP.logUserAction({ action: "deleteButton" });
          }}
        >
          <TrashBinSvg />
        </SvgButton>
      </span>
    </ZaunCircleMenuItem>
  );
}
